module.exports = __webpack_public_path__ + "media/images/marketing-banner/installation-2-197a7f65a6a50c90363a25edfda799be.png";